namespace TabAurous.Inventory {
    export interface StockEnquiryRow {
        StockId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        TransId?: number;
        TransItemId?: number;
        VoucherDate?: string;
        VoucherTypeName?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        CompanyId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        Lab?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ProductId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        Rate?: number;
        ImageName?: string;
        FinancialYearId?: number;
        RefVoucherId?: number;
        Purity?: number;
        PureWeight?: number;
        POSCustomerId?: number;
        SetId?: number;
        StockAllocation?: boolean;
        MFAmount?: number;
        MF?: number;
        BOMDetails?: Stock.StockItemBOMRow[];
        HistoryDetails?: Stock.StockItemRow[];
        DeptName?: string;
        LedgerName?: string;
        PartyCode?: string;
        CompanyCode?: string;
        ProductCode?: string;
        ProductName?: string;
        IsCustomerItem?: boolean;
        HasBom?: boolean;
        TaxCode?: string;
        HSN?: string;
        CostMethodId?: number;
        MetalId?: number;
        DesignId?: number;
        Parts?: number;
        Image1?: string;
        Image2?: string;
        Image3?: string;
        ItemType?: string;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        StoneSizeName?: string;
        SieveName?: string;
        StoneColoreName?: string;
        QualityName?: string;
        ShapeName?: string;
        MetalColorName?: string;
        HUID?: string;
        ExportPieces?: number;
        KaratName?: string;
        StoneCutId?: number;
        StoneCutCode?: string;
        StoneCutName?: string;
        StonePolishId?: number;
        StonePolishCode?: string;
        StonePolishName?: string;
        StoneSymmetryId?: number;
        StoneSymmetryCode?: string;
        StoneSymmetryName?: string;
        StoneFluorescenceId?: number;
        StoneFluorescenceCode?: string;
        StoneFluorescenceName?: string;
        StoneCuletId?: number;
        StoneCuletCode?: string;
        StoneCuletName?: string;
        StoneGirdleId?: number;
        StoneGirdleCode?: string;
        StoneGirdleName?: string;
        StoneTable?: string;
        StoneDepth?: string;
        BrandName?: string;
        CollectionName?: string;
        SuperTypeName?: string;
        MetalName?: string;
        BOMCategoryName?: string;
        BOMSubCategoryName?: string;
        BOMStoneColoreName?: string;
        BOMQualityName?: string;
        BOMShapeName?: string;
        BOMMetalColorName?: string;
        BOMKaratName?: string;
        BOMPurity?: number;
        BOMPureWeight?: number;
        BOMStoneSizeName?: string;
        BOMSieveName?: string;
        BOMGroupSieveName?: string;
        BomRate?: number;
        BomAmount?: number;
    }

    export namespace StockEnquiryRow {
        export const idProperty = 'StockId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Inventory.StockEnquiry';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            StockId = "StockId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            TransId = "TransId",
            TransItemId = "TransItemId",
            VoucherDate = "VoucherDate",
            VoucherTypeName = "VoucherTypeName",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            CompanyId = "CompanyId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            Lab = "Lab",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            Rate = "Rate",
            ImageName = "ImageName",
            FinancialYearId = "FinancialYearId",
            RefVoucherId = "RefVoucherId",
            Purity = "Purity",
            PureWeight = "PureWeight",
            POSCustomerId = "POSCustomerId",
            SetId = "SetId",
            StockAllocation = "StockAllocation",
            MFAmount = "MFAmount",
            MF = "MF",
            BOMDetails = "BOMDetails",
            HistoryDetails = "HistoryDetails",
            DeptName = "DeptName",
            LedgerName = "LedgerName",
            PartyCode = "PartyCode",
            CompanyCode = "CompanyCode",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            IsCustomerItem = "IsCustomerItem",
            HasBom = "HasBom",
            TaxCode = "TaxCode",
            HSN = "HSN",
            CostMethodId = "CostMethodId",
            MetalId = "MetalId",
            DesignId = "DesignId",
            Parts = "Parts",
            Image1 = "Image1",
            Image2 = "Image2",
            Image3 = "Image3",
            ItemType = "ItemType",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            StoneSizeName = "StoneSizeName",
            SieveName = "SieveName",
            StoneColoreName = "StoneColoreName",
            QualityName = "QualityName",
            ShapeName = "ShapeName",
            MetalColorName = "MetalColorName",
            HUID = "HUID",
            ExportPieces = "ExportPieces",
            KaratName = "KaratName",
            StoneCutId = "StoneCutId",
            StoneCutCode = "StoneCutCode",
            StoneCutName = "StoneCutName",
            StonePolishId = "StonePolishId",
            StonePolishCode = "StonePolishCode",
            StonePolishName = "StonePolishName",
            StoneSymmetryId = "StoneSymmetryId",
            StoneSymmetryCode = "StoneSymmetryCode",
            StoneSymmetryName = "StoneSymmetryName",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneFluorescenceCode = "StoneFluorescenceCode",
            StoneFluorescenceName = "StoneFluorescenceName",
            StoneCuletId = "StoneCuletId",
            StoneCuletCode = "StoneCuletCode",
            StoneCuletName = "StoneCuletName",
            StoneGirdleId = "StoneGirdleId",
            StoneGirdleCode = "StoneGirdleCode",
            StoneGirdleName = "StoneGirdleName",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            BrandName = "BrandName",
            CollectionName = "CollectionName",
            SuperTypeName = "SuperTypeName",
            MetalName = "MetalName",
            BOMCategoryName = "BOMCategoryName",
            BOMSubCategoryName = "BOMSubCategoryName",
            BOMStoneColoreName = "BOMStoneColoreName",
            BOMQualityName = "BOMQualityName",
            BOMShapeName = "BOMShapeName",
            BOMMetalColorName = "BOMMetalColorName",
            BOMKaratName = "BOMKaratName",
            BOMPurity = "BOMPurity",
            BOMPureWeight = "BOMPureWeight",
            BOMStoneSizeName = "BOMStoneSizeName",
            BOMSieveName = "BOMSieveName",
            BOMGroupSieveName = "BOMGroupSieveName",
            BomRate = "BomRate",
            BomAmount = "BomAmount"
        }
    }
}
